import { Controller } from "stimulus";
import Cookies from "js-cookie";

export default class extends Controller {

  setCookie() {
    Cookies.set("portfolio_announcement_dismissed", "true");
  }
}
